import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Icon } from "react-icons-kit";
import { loop2 } from "react-icons-kit/icomoon/loop2";
import { download3 } from "react-icons-kit/icomoon/download3";
import { useImageMemoryCacheForDocument } from "../../../../../utils/hooks/useImageCache";
import requestAPI from "../../../../../helpers/requestHelpers";
import * as urlsApi from "../../../../../utils/contants/urlsApi";

const ImageViewerPage = () => {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const url = params.get("url");
  const documentId = params.get("documentId");

  const [rotation, setRotation] = useState(0);
  const [isZoom, setIsZoom] = useState(false);
  const [zoomOrigin, setZoomOrigin] = useState({ x: "50%", y: "50%" });
  const [imageLoaded, setImageLoaded] = useState(false);
  const previousObjectUrlRef = useRef(null);

  const getFileBlob = useCallback(async (id) => {
    const resp = await requestAPI({
      verb: "POST",
      endPoint: `${urlsApi.GET_DOCUMENT_FILE}?idDocumentoCandidato=${encodeURIComponent(id)}`,
      data: null,
      responseType: "blob",
    });

    console.log("resp", resp);

    if (resp instanceof Blob) return resp;
    if (resp?.data instanceof Blob) return resp.data;
    if (resp?.data instanceof ArrayBuffer) return new Blob([resp.data]);

    throw new Error("Resposta inesperada do requestAPI");
  }, []);

  const { objectUrl, fetch, download, loading, error } = useImageMemoryCacheForDocument(documentId, {
    autoFetch: false,
    getFileBlob,
  });

  useEffect(() => {
    if (documentId) fetch().catch((err) => console.error(err));
  }, [documentId, fetch]);

  useEffect(() => {
    if (!objectUrl) return;

    if (previousObjectUrlRef.current && imageLoaded) {
      try {
        URL.revokeObjectURL(previousObjectUrlRef.current);
      } catch (e) {
        console.warn("Erro ao revogar objectUrl anterior:", e);
      }
      previousObjectUrlRef.current = null;
    }
    previousObjectUrlRef.current = objectUrl;
    setImageLoaded(false);
  }, [objectUrl, imageLoaded]);

  useEffect(() => {
    return () => {
      const urlToRevoke = previousObjectUrlRef.current;
      if (urlToRevoke) {
        try {
          URL.revokeObjectURL(urlToRevoke);
        } catch (e) {
          console.warn("Erro ao revogar objectUrl no unmount:", e);
        }
        previousObjectUrlRef.current = null;
      }
    };
  }, []);

  if (!url) {
    return <p>Nenhuma imagem encontrada</p>;
  }

  const handleDownload = async () => {
    try {
      if (!objectUrl) await fetch();
      await download(`document-${documentId}.png`);
    } catch (err) {
      console.error("Erro ao salvar imagem:", err);
      alert("Erro ao baixar imagem: " + (err?.message || err));
    }
  };

  const handleImageClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const offsetX = ((e.clientX - rect.left) / rect.width) * 100;
    const offsetY = ((e.clientY - rect.top) / rect.height) * 100;

    setZoomOrigin({ x: `${offsetX}%`, y: `${offsetY}%` });
    setIsZoom((prev) => !prev);
  };

  const imgSrc = objectUrl;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#f3f4f6",
      }}
    >
      <div
        style={{
          position: "relative",
          backgroundColor: "white",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          borderRadius: 16,
          padding: 16,
          width: "90%",
          maxWidth: 1000,
          height: "90%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <button
          onClick={() => history.goBack()}
          style={{
            position: "absolute",
            top: 16,
            right: 16,
            fontSize: 28,
            fontWeight: "bold",
            color: "#005156",
            border: "none",
            background: "none",
            cursor: "pointer",
          }}
        >
          &times;
        </button>

        <div style={{ display: "flex", gap: 24, paddingTop: 32, paddingLeft: 16 }}>
          <button
            onClick={() => setRotation((prev) => prev + 90)}
            style={{ border: "none", background: "none", cursor: "pointer", color: "#005156" }}
            title="Rotacionar"
          >
            <Icon icon={loop2} size={30} />
          </button>

          <button
            onClick={handleDownload}
            style={{ border: "none", background: "none", cursor: "pointer", color: "#005156" }}
            title="Baixar"
            disabled={loading}
          >
            <Icon icon={download3} size={30} />
          </button>

          {loading && <div style={{ alignSelf: "center", color: "#666" }}>Carregando...</div>}
          {error && <div style={{ color: "red", alignSelf: "center" }}>Erro: {error.message}</div>}
        </div>

        <div
          style={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              transform: `rotate(${rotation}deg)`,
              transition: "transform 0.3s ease",
              display: "inline-block",
            }}
          >
            {imgSrc ? (
              <img
                src={imgSrc}
                alt="Visualização"
                onClick={handleImageClick}
                onLoad={() => {
                  console.log("Imagem carregada com sucesso");
                  setImageLoaded(true);
                }}
                onError={() => {
                  console.warn("Erro ao carregar a imagem a partir de objectUrl");
                }}
                style={{
                  cursor: "zoom-in",
                  transform: `scale(${isZoom ? 1.5 : 1})`,
                  transformOrigin: `${zoomOrigin.x} ${zoomOrigin.y}`,
                  transition: "transform 0.3s ease",
                  objectFit: "contain",
                  maxWidth: rotation % 180 === 0 ? "100%" : "70vh",
                  maxHeight: rotation % 180 === 0 ? "70vh" : "100%",
                  display: "block",
                }}
              />
            ) : (
              <div style={{ color: "#666" }}>Carregando imagem...</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageViewerPage;